import React from "react"
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect"
import CustomSwitch from "../../../../components/CustomSwitch"
import { ConstantService } from "../../../../services/ConstantService"
import { KTCard } from "../../../../_metronic/helpers/components/KTCard"
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody"

interface Props {
    generalInformationRef: any
    selectedBaseAntrepo: CustomSingleSelectModel | undefined
    setSelectedBaseAntrepo: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    code: string | undefined
    setCode: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedAntrepoType: CustomSingleSelectModel | undefined
    setSelectedAntrepoType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    phone1Ref: React.MutableRefObject<HTMLInputElement | null>
    phone1: string | undefined
    setPhone1: React.Dispatch<React.SetStateAction<string | undefined>>
    email: string | undefined
    setEmail: React.Dispatch<React.SetStateAction<string | undefined>>
    isCustomActive: boolean | undefined
    setIsCustomActive: React.Dispatch<React.SetStateAction<boolean | undefined>>
    volumeCapacity: string | undefined
    setVolumeCapacity: React.Dispatch<React.SetStateAction<string | undefined>>
    palletCapacity: string | undefined
    setPalletCapacity: React.Dispatch<React.SetStateAction<string | undefined>>
}

const GeneralInformation = ({
    generalInformationRef,
    selectedBaseAntrepo,
    setSelectedBaseAntrepo,
    code,
    setCode,
    selectedAntrepoType,
    setSelectedAntrepoType,
    phone1Ref,
    phone1,
    setPhone1,
    email,
    setEmail,
    isCustomActive,
    setIsCustomActive,
    setVolumeCapacity,
    volumeCapacity,
    palletCapacity,
    setPalletCapacity
}: Props) => {
    return (
        <div className='containerPart' ref={generalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className='row'>
                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Kod</label>
                                <input disabled style={{ border: '1px solid #F1F1F4' }} value={code} onChange={(e) => setCode(e.target.value)} type="text" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Antrepo</label>

                                <CustomSingleSelect
                                    selectedValue={selectedBaseAntrepo}
                                    onChange={setSelectedBaseAntrepo}
                                    onMenuOpen={() => ConstantService.getConstantList('ANTREPO_UNIT')}
                                    label2Name='value'
                                    labelName="additionalValue1"
                                    valueName='constantId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Antrepo Türü</label>

                                <CustomSingleSelect
                                    selectedValue={selectedAntrepoType}
                                    onChange={setSelectedAntrepoType}
                                    onMenuOpen={() => ConstantService.getConstantList('ANTREPO_TYPE')}
                                    labelName="value"
                                    valueName='constantId'
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Telefon 1</label>
                                <input ref={phone1Ref} style={{ border: '1px solid #F1F1F4' }} value={phone1} onChange={(e) => setPhone1(e.target.value)} className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">E-Posta</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={email} onChange={(e) => setEmail(e.target.value)} type="text" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Palet Kapasite</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={palletCapacity} onChange={(e) => setPalletCapacity(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Hacim Kapasite</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={volumeCapacity} onChange={(e) => setVolumeCapacity(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation